<template>
    <li>
        <div class="bax-collapse">
          <div :class="'bax-collapse-header align-items-start tpn-product ' + (drug.editRequired?'edit-required-yes':'edit-required-no')" v-if="isTPN()">
            <strong><span>{{drug.tpn_product}} {{  drug.onHold }}</span></strong>
            <div class="d-md-flex align-items-center">
              <table class="delivery-date-array">
                <tr>
                  <th>Qty</th>
                  <th>Delivery Date</th>
                </tr>
                <tr v-for="(deliveryDateSet, index) in drug.deliveryDateArray"
                    :key="index"
                >
                  <td>{{deliveryDateSet[2]}}</td>
                  <td>{{deliveryDateSet[0]}}</td>
                </tr>
              </table>
              <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
                <div class="bax-order-action-item">
                    <ul class="d-md-flex justify-content-end">
                    <li>
                        <a
                                href="#"
                                class="bax-btn bax-btn-bordered bax-btn-bordered-txtcolor"
                                @click.prevent="isTPN() ? deleteProduct() : deleteDrug()"
                        >
                        <i class="icon-delete"></i> Remove
                        </a>
                    </li>
                    <li>
                        <router-link :to="{
                                name: 'editOrderDrugTPN',
                                params: {
                                    orderId: $route.params.orderId,
                                },
                                query: {
                                    patient_id: drug.patientId,
                                    drug: drug.orderLineItemId,
                                    from: $route.name,
                                }
                            }" class="bax-btn bax-btn-bordered bax-btn-bordered-txtcolor">
                        <i class="icon-edit"></i>Edit
                        </router-link>
                    </li>
                    </ul>
                </div>
              </template>
            </div>
          </div>
            <div :class="'bax-collapse-header d-md-flex align-items-center ' + (drug.editRequired?'edit-required-yes':'edit-required-no')"  @click.prevent="toggle" v-if="!isTPN()">
                <strong v-if="!isTPN()"> {{ drug.drug1Name }}
                    {{ drug.type === 'FP' ? drug.drug1GenericName : drug.drug1Name || drug.drug1_name || drug.drugName }}
                    <span className="text" v-if="drug.type === 'FP' && drug.drug2GenericName !== ''">& {{ drug.drug2GenericName }}</span>
                    <span v-if="drug.type !== 'FP' && drug.drug2_name !== null">& {{ drug.drug2_name }}</span>
                    <span v-if="drug.onHold" class="text-sm text-yellow-500">- ON HOLD</span>
                </strong>
                <span class="ml-auto d-block mt-3 mt-md-0">
                    {{ open === true ? 'Hide details' : 'Show details' }}
                    <i v-bind:class="[open === true ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
                </span>
            </div>
        </div>
      <div :class="'bax-collapse-header d-md-flex align-items-center ' + (drug.editRequired?'edit-required-yes':'edit-required-no')"  @click.prevent="toggle" v-if="!isTPN()">
      </div>
        <div class="bax-order-summary" v-if="open === true">
            <ul>
              <li class="d-md-flex" v-if="drug.type === 'FP'">
                <span>Product Code:</span>
                <strong class="ml-auto text-md-right">{{ drug.finishedProductCode }}</strong>
              </li>
                <li class="d-md-flex" v-if="drug.overrideStability || drug.overrideDosage">
                    <span>Alerts: </span>
                    <strong class="ml-auto text-md-right">
                        <span v-if="drug.overrideStability">No system stability exists for this drug</span>
                        <span>{{ maxDoseWarningMsg() }}</span>
                    </strong>
                </li>
                <li class="delivery-date-display" v-if="drug.deliveryDateArray">
                    <table>
                        <tr>
                            <th>Qty</th>
                            <th>Delivery Date</th>
                            <th>Treatment Date</th>
                        </tr>
                        <tr v-for="(deliveryDateSet, index) in drug.deliveryDateArray"
                            :key="index"
                        >
                            <td>{{deliveryDateSet[2]}}</td>
                            <td>{{deliveryDateSet[0]}}</td>
                            <td>{{deliveryDateSet[1]?deliveryDateSet[1]:'Unspecified'}}</td>
                        </tr>
                    </table>
                </li>
              <li class="d-md-flex" v-if="drug.type === 'TPN'">
                <span>Product Code:</span>
                <strong class="ml-auto text-md-right">{{ drug.tpn_code }}</strong>
              </li>
                <li class="d-md-flex" v-if="drug.drug1Dose">
                    <span>Dose {{drug.type === 'FP' ? drug.drug1GenericName : drug.drug1_name}}: </span>
                    <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug1Dose) }} {{ drug.drug1UOM?drug.drug1UOM:drug.drug1_maxdose_uom }}</strong>
                </li>
                <li class="d-md-flex" v-if="(typeof drug.drug2_id !== 'undefined') && (drug.drug2_id !== null)">
                    <span>Dose {{drug.drug2_name}}:</span>
                    <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug2Dose) }} {{ drug.drug2UOM?drug.drug2UOM:drug.drug2_maxdose_uom }}</strong>
                </li>
                <li class="d-md-flex" v-if="(typeof drug.drug2GenericName !== 'undefined') && (drug.drug2GenericName !== null) && (drug.drug2GenericName)">
                    <span>Dose {{drug.drug2GenericName}}:</span>
                    <strong class="ml-auto text-md-right">{{ rounddec_2(drug.drug2Dose) }} {{ drug.drug2UOM?drug.drug2UOM:drug.drug2_maxdose_uom }}</strong>
                </li>
                <li class="d-md-flex" v-if="drug.administrationRouteDescription || drug.admin_route_desc">
                    <span>Route: </span>
                    <strong class="ml-auto text-md-right">
                        {{ drug.type === 'FP' ? drug.administrationRouteDescription : drug.admin_route_desc }}
                    </strong>
                </li>
                <li class="d-md-flex" v-if="drug.deviceGenericName || drug.container_type_name || drug.container">
                    <span>Container: </span>
                    <strong class="ml-auto text-md-right">
                        {{ drug.type === 'FP' ? drug.deviceGenericName : (drug.container_type_name == 'FluidBag' ? drug.container_type_name : drug.container )}}
                    </strong>
                </li>
                <li class="d-md-flex" v-if="(typeof drug.diluentGenericName !== 'undefined') && (drug.diluentGenericName != '')">
                  <span>Diluent:</span>
                  <strong class="ml-auto text-md-right">{{ drug.diluentGenericName }}</strong>
                </li>
                <li class="d-md-flex" v-else-if="typeof drug.diluent !== 'undefined' &&typeof drug.diluent !== 'object' && drug.diluent != ''" >
                  <span>Diluent:</span>
                  <strong class="ml-auto text-md-right">{{ drug.diluent }}</strong>
                </li>
                <li class="d-md-flex" v-if="(drug.type === 'FP' && drug.totalVolume) || drug.diluentVolume">
                    <span>{{drug.diluentExactFinalVolume ? "Exact Final Vol:" : "Container Vol:" }}</span>
                    <strong class="ml-auto text-md-right">
                        {{ rounddec_2(drug.type === 'FP' ? drug.totalVolume : drug.diluentVolume) }} mL
                    </strong>
                </li>
              <li class="d-md-flex" v-if="(typeof drug.infusionTime !== 'undefined') && (typeof drug.infusionTime !== 'object') && (drug.infusionTime !== '') && !isNaN(drug.infusionTime)">
                <span>Infusion time:</span>
                <strong class="ml-auto text-md-right">{{ this.rounddec_2(drug.infusionTime) }} {{ drug.infusionTimeDuration?drug.infusionTimeDuration:drug.infusionTimeDuration }} </strong>
              </li>
                <li class="d-md-flex" v-if="!drug.deliveryDateArray">
                    <span>Treatment Date: </span>
                    <strong class="ml-auto text-md-right d-md-flex" v-if="drug.type === 'FP'">
                        {{ typeof (drug.treatmentDate !== 'undefined') && (drug.treatmentDate) ? drug.treatmentDateFormatted : '--' }}
                    </strong>
                    <strong class="ml-auto text-md-right d-md-flex" v-else>
                        {{ (typeof drug.treatmentDateFormatted !== 'undefined') && (drug.treatmentDateFormatted) ? drug.treatmentDateFormatted : '--' }}
                    </strong>
                </li>


                <li class="d-md-flex" v-if="((drug.ancillary1GenericName) && (drug.ancillary1GenericName !== '')) || (drug.ancillary1Name) || (drug.ancillary2Name)">
                    <span>Ancillary: </span>
                    <strong class="ml-auto text-md-right" v-if="drug.type === 'FP'">
                        {{ drug.ancillary1GenericName }}
                    </strong>
                    <strong class="ml-auto text-md-right" v-else>
                        {{ drug.ancillary1Name ? drug.ancillary1Name : '' }}{{ drug.ancillary2Name ? ', ' + drug.ancillary2Name : '' }}
                    </strong>
                </li>
            </ul>
            <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
                <div class="bax-order-action-item">
                    <ul class="d-md-flex justify-content-end">
                        <li>
                            <a
                                href="#"
                                class="bax-btn bax-btn-bordered bax-btn-bordered-txtcolor"
                                @click.prevent="isTPN() ? deleteProduct() : deleteDrug()"
                            >
                                <i class="icon-delete"></i> Remove
                            </a>
                        </li>
                        <li v-if="!isTPN()">
                            <router-link :to="{
                                name: 'editOrderDrug',
                                params: {
                                    orderId: $route.params.orderId,
                                },
                                query: {
                                    patient_id: drug.patientId,
                                    drug: drug.orderLineItemId,
                                    from: $route.name,
                                }
                            }" class="bax-btn bax-btn-white">
                                <i class="icon-edit"></i>Edit
                            </router-link>
                        </li>
                    <li v-if="isTPN()">
                        <router-link :to="{
                                name: 'editOrderDrugTPN',
                                params: {
                                    orderId: $route.params.orderId,
                                },
                                query: {
                                    patient_id: drug.patientId,
                                    drug: drug.orderLineItemId,
                                    from: $route.name,
                                }
                            }" class="bax-btn bax-btn-bordered bax-btn-bordered-txtcolor">
                        <i class="icon-edit"></i>Edit
                        </router-link>
                    </li>                </ul>
                </div>
            </template>
        </div>
        <br v-if="open === true" />
    </li>
</template>

<script>

import utilsMixin from '@/mixins/utilsMixin';
import tpnMixin from '@/mixins/tpnMixin';
import { mapGetters } from 'vuex';

export default {
    name: 'OrderSummaryPatientDrug',
    mixins: [utilsMixin, tpnMixin],
    props: {
        drug: {
            type: Object,
        },
        color: {
            default: '',
        },
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        openDetails() {
            this.open = true;
            // this.$emit('item-open');
        },
        closeDetails() {
            this.open = false;
            this.$emit('item-close');
        },
        toggle() {
            if (this.open === true) {
                this.closeDetails();
            } else {
                this.openDetails();
            }
        },
        deleteDrug() {
            this.$emit('delete-drug');
        },
        deleteProduct() {
            this.$emit('delete-product');
        },
        maxDoseWarningMsg() {
            if (this.drug.overrideDosage || this.drug.drug1Dose > this.drug.drug1_maxdose || this.drug.drug2Dose > this.drug.drug2_maxdose) {
                return "Max dosage exceeded for this drug";
            }
            return '';
        },
    },
};
</script>
